module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/298.3b442b96.png";